import React, { Component } from 'react';
import { Modal, Spin, Tabs, Input, Button, DatePicker, message, Tag } from 'antd';
import TableC from '../../basicElement/TableC';
import Text from '../../basicElement/Text';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import deepClone from '../../shared/deepClone';
import format from '../../shared/format';
import moment from 'moment';

const { TabPane } = Tabs;
const { MonthPicker } = DatePicker;
const LANGUAGE = {
    true: 'CHINESE',
    false: 'ENGLISH'
};

// 项目明细
const CONFIG_DETAIL = {
    CHINESE: {
        investigationArea: '项目领域',
        disease: '疾病',
        projectRole: '项目角色',
        projectType: '项目类型',
        researchProductType: '研究产品类型',
        projectPhase: '项目分期',
        investigationName: '项目简称',
        projectStage: '项目阶段',
        joinTime: '参与时间',
        present: '不填写代表至今',
    },
    ENGLISH: {
        investigationArea: 'Therapeutic Area',
        disease: 'Indications',
        projectRole: 'Role',
        projectType: 'Study Type',
        researchProductType: 'Investigational Product Type',
        projectPhase: 'Study Phase',
        investigationName: 'Study Name',
        projectStage: 'Study Stage',
        joinTime: 'Time',
        present: 'Present',
    },
    COMBINE_TEXT: '合并'
};

// 更新日志
const CONFIG_LOG = {
    CHINESE: {
        personalInfo: '个人信息',
        workHistory: '工作经历',
        clinicalTrialExp: '临床试验经验',
        education: '教育背景',
        trainingExp: '培训经历',
        systemExp: '使用系统经验',
        licence: '执照/许可证/证书',
        language: '语言/流利度',
    },
    ENGLISH: {
        personalInfo: 'Personal Profile',
        workHistory: 'Work History',
        clinicalTrialExp: 'Clinical Trial Experience',
        education: 'Education',
        trainingExp: 'Training Experience',
        systemExp: 'System Experience',
        licence: 'Licences/Certificates',
        language: 'Languages/Fluency',
    },
    type: {
        personalInfo: 'PERSON_INFO',
        workHistory: 'VITAE_WORK_EXPERIENCE',
        clinicalTrialExp: 'VITAE_CLINICAL_EXPERIENCE',
        education: 'VITAE_EDUCATION',
        trainingExp: 'VITAE_TRAINING_EXPERIENCE',
        systemExp: 'VITAE_SYSTEM_EXPERIENCE',
        licence: 'LICENCES_CERTIFICATES_NAME',
        language: 'VITAL_LANGUAGE',
    }
};

class ProDetail extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = record => {
        const { childrens, ...rest } = record;
        this.setState({
            record: rest,
            data: deepClone(childrens),
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    confirm = (index) => {
        const { data } = this.state;
        if (data[index].experienceType === 'MEDKEY') {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: <div style={{ marginLeft: 42 }}>确定要修改吗？</div>,
                content: '自动生成的临床试验经验一旦修改后，系统将不再自动维护',
                onOk: () => {
                    this.save(index);
                }
            });
        } else {
            this.save(index);
        }
    }

    save = index => {
        const { data } = this.state;
        const target = data[index];
        const { clinicalStartTime, clinicalEndTime } = target;

        if (!clinicalStartTime) {
            message.warning('请选择参与时间！');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.personal.modifyVitaeClinicalExperience, {
            ...target,
            clinicalStartTime: format('month', clinicalStartTime),
            clinicalEndTime: format('month', clinicalEndTime),
            experienceType: 'MEDKEY_MODIFY',
        }).then((res) => {
            message.success(res.success);
            target.experienceType = 'MEDKEY_MODIFY';
            this.setState({
                data,
                loading: false,
            }, () => {
                this.update(index, false);
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const { isChinese ,canEdit } = this.props;
        const columns = [{
            title: CONFIG_DETAIL[LANGUAGE[isChinese]].investigationName,
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 180,
            render: text => text === CONFIG_DETAIL.COMBINE_TEXT ? <strong>{CONFIG_DETAIL.COMBINE_TEXT}</strong> : text,
        }, {
            title: CONFIG_DETAIL[LANGUAGE[isChinese]].projectStage,
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
        }, {
            title: CONFIG_DETAIL[LANGUAGE[isChinese]].projectRole,
            dataIndex: 'invRoleCode',
            key: 'invRoleCode',
            width: 100,
        }, {
            title: CONFIG_DETAIL[LANGUAGE[isChinese]].joinTime,
            dataIndex: 'joinTime',
            key: 'joinTime',
            render: (text, record, index) => {
                const { editable, experienceType, investigationName, clinicalStartTime, clinicalEndTime } = record;
                if (editable) {
                    return (
                        <div style={{display: 'inline-block'}}>
                            <MonthPicker
                                style={{width: 120}}
                                value={clinicalStartTime ? moment(clinicalStartTime) : null}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'clinicalStartTime', index)}
                            />
                            <span style={{margin: '0 6px'}}>~</span>
                            <MonthPicker
                                style={{width: 120}}
                                value={clinicalEndTime ? moment(clinicalEndTime) : null}
                                placeholder={CONFIG_DETAIL[LANGUAGE[isChinese]].present}
                                onChange={(date, dateString) => this.handleDateChange(date, dateString, 'clinicalEndTime', index)}
                            />
                        </div>
                    )
                } else {
                    return (
                        <span style={{ fontWeight: investigationName === CONFIG_DETAIL.COMBINE_TEXT ? 'bold' : 'normal' }}>
                            {format('month', clinicalStartTime)}~{clinicalEndTime ? format('month', clinicalEndTime) : isChinese ? '至今' : 'Present'}
                            {isChinese && experienceType === 'MEDKEY' && <Tag color="#ffa500" style={{marginLeft: 6}}>自动</Tag>}
                        </span>
                    )
                }
            }
        }];
        if (isChinese) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    const { editable, investigationName } = record;
                    if (investigationName !== CONFIG_DETAIL.COMBINE_TEXT) {
                        return (
                            editable ?
                                <span>
                                    <a onClick={() => this.confirm(index)}>保存</a>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.update(index, false)}>取消</a>
                                </span>
                            :
                            canEdit && <a onClick={() => this.update(index, true)}>修改</a>
                        );
                    }
                },
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [...data];
        if ((data || []).length) {
            dataSource.push({
                investigationName: CONFIG_DETAIL.COMBINE_TEXT,
                clinicalStartTime: data[0].clinicalStartTime,
                clinicalEndTime: data[data.length - 1].clinicalEndTime,
            });
        }

        return dataSource;
    }

    update = (index, editable) => {
        this.setState(prevState => {
            prevState.data[index].editable = editable;
            return prevState.data;
        });
    }

    handleDateChange = (date, dateString, key, index) => {
        this.setState(prevState => {
            prevState.data[index][key] = dateString;
            return prevState.data;
        });
    }

    render() {
        const { isChinese } = this.props;
        const { visible, loading, record } = this.state;
        const { investigationAreaName, diseaseName, clinicalRoleName, clinicalTypeName, investigationProductName, investigationProductStageName } = record;
        return (
            <Modal
                title="项目明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
                maskClosable={false}
                width="800px"
            >
                <Spin spinning={loading}>
                    <div style={{ padding:'10px 20px' }}>
                        <table cellPadding='0' cellSpacing='0' className="distribute information">
                            <tbody>
                                <tr>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].investigationArea}：</td>
                                    <td className="distribute_td_right col-2-5">{investigationAreaName}</td>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].disease}：</td>
                                    <td className="distribute_td_right col-2-5">{diseaseName}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].projectRole}：</td>
                                    <td className="distribute_td_right col-2-5">{clinicalRoleName}</td>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].projectType}：</td>
                                    <td className="distribute_td_right col-2-5">{clinicalTypeName}</td>
                                </tr>
                                <tr>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].researchProductType}：</td>
                                    <td className="distribute_td_right col-2-5">{investigationProductName}</td>
                                    <td className="distribute_td_left need-bold col-2-5">{CONFIG_DETAIL[LANGUAGE[isChinese]].projectPhase}：</td>
                                    <td className="distribute_td_right col-2-5">{investigationProductStageName}</td>
                                </tr>
                            </tbody>
                        </table>
                        <TableC
                            scrollY={220}
                            data={this.getDataSource()}
                            columns={this.getColumns()}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

class LogList extends Component {
    state = {
        data: []
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.loadData();
        }
    }

    loadData = () => {
        const { type, ownerId, languageType } = this.props;
        this.setState({ loading: true });
        Fetch.post(API_URL.personal.queryVitaeLog, {
            languageType,
            ownerId,
            type
        }).then((res) => {
            const { data } = res;
            this.setState({ data });
        }).catch(err => {
            console.error(err);
        });
    }

    getColumns = () => {
        const columns = [{
            title: '字段',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        }, {
            title: '更新前',
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: 370,
        }, {
            title: '更新后',
            dataIndex: 'newValue',
            key: 'newValue',
        }];
        return columns;
    }

    render() {
        const { data } = this.state;
        return (
            <div style={{ height: 500, overflowY: 'auto' }}>
                {
                    (data || []).length > 0 ?
                        data.map(item => {
                            const { vitaeLogId, createTime, userCompellation, employeeCode, detailList } = item;
                            return (
                                <div key={vitaeLogId} style={{marginBottom: 20}}>
                                    <div style={{marginBottom: 4, fontWeight: 'bold'}}>
                                        更新时间：{createTime}
                                        <span className="ant-divider" />
                                        更新者：{userCompellation}({employeeCode})
                                    </div>
                                    <TableC
                                        data={detailList}
                                        columns={this.getColumns()}
                                    />
                                </div>
                            );
                        })
                    :
                        <div style={{ lineHeight: '320px', textAlign: 'center' }}>暂无更新</div>
                }
            </div>
        );
    }
}

class UpdateLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            panes: [{
                key: 'workHistory',
                content: this.getContent,
            }, {
                key: 'clinicalTrialExp',
                content: this.getContent,
            }, {
                key: 'education',
                content: this.getContent,
            }, {
                key: 'trainingExp',
                content: this.getContent,
            }, {
                key: 'systemExp',
                content: this.getContent,
            }, {
                key: 'licence',
                content: this.getContent,
            }, {
                key: 'language',
                content: this.getContent,
            }],
            activeKey: '',
            visible: false,
        };
    }

    show = () => {
        const { isChinese } = this.props;
        const { panes } = this.state;
        let activeKey = 'workHistory';
        if (!isChinese) {
            activeKey = 'personalInfo';
            panes.unshift({
                key: 'personalInfo',
                content: this.getContent,
            });
        }
        this.setState({
            activeKey,
            visible: true,
        });
    }

    hide = () => {
        const { isChinese } = this.props;
        const { panes } = this.state;
        if (!isChinese) {
            panes.shift();
        }
        this.setState({
            visible: false,
            activeKey: '',
            panes,
        });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    getContent = (key) => {
        const { ownerId, isChinese } = this.props;
        const { activeKey } = this.state;
        if (activeKey == key) {
            return <LogList ownerId={ownerId} type={CONFIG_LOG['type'][activeKey]} languageType={LANGUAGE[isChinese]} />;
        } else {
            return null;
        }
    }

    render() {
        const { isChinese } = this.props;
        const { panes, visible, activeKey } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                bodyStyle={{maxHeight:600}}
                footer={<Button onClick={this.hide}>关闭</Button>}
                maskClosable={false}
                width="1000px"
            >
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={CONFIG_LOG[LANGUAGE[isChinese]][pane.key]} key={pane.key}>{pane.content(pane.key)}</TabPane>)}
                </Tabs>
            </Modal>
        );
    }
}

class ChangeName extends Component {
    state = {
        name: '',
        visible: false,
        loading: false,
    }

    show = (name) => {
        this.setState({
            name,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { userId } = this.props;
        const { name } = this.state;
        if (!name) {
            message.warning('Please Select Name！');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.personal.saveVitaeEnglishName, {
            userId,
            name,
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    handleChange = (e) => {
        this.setState({ name: e.target.value });
    }

    getContent = () => {
        const { name } = this.state;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={true} colon={true}>Name</Text></div>
                    <div className="item-right">
                        <Input
                            placeholder="Please Select"
                            style={{ width: 182 }}
                            value={name}
                            onChange={this.handleChange}
                        />
                    </div>
                </li>
            </ul>
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="修改英文名"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export { ProDetail, UpdateLog, ChangeName };


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/Widget.js